import { z } from 'zod';

import { Address, PaymentAddress } from '../../Address';
import { CompanyId } from '../../BrandedIds';
import { CompanyLogos } from '../../Logos';
import { SupportHours } from '../../SupportHours';

export const ExportableCompany = z
  .object({
    id: CompanyId,
    name: z.string(),

    supportEmail: z.string(),
    address: Address.optional(),
    paymentAddress: PaymentAddress.optional(),
    supportPhone: z.string(),
    supportHours: SupportHours.optional(),
    website: z.string().optional(),
    paymentsPaused: z.boolean(),
    logos: CompanyLogos,

    ein: z.string().optional(),
    emailDomain: z.string().optional(),
    emailFrom: z.string().optional(),
    ssoDomains: z.string().array(),
    portalDomain: z.string().optional(),
  })
  .meta({ title: 'Company' });
export type ExportableCompany = z.infer<typeof ExportableCompany>;
